import React from 'react';
import PopupGrid from './PopupGrid';

const PopupGridContainer = ({ close }: { close: () => void }) => {
  return <PopupGrid close={close} />;
};

export default PopupGridContainer;
